// extracted by mini-css-extract-plugin
export default {"alert":"ActionAlert_alert__T8c45","message":"ActionAlert_message__ZR0MC","icon":"ActionAlert_icon__ow9Wq","critical":"ActionAlert_critical__D-bQ7","ok":"ActionAlert_ok__JB+zM"};